module.exports = __webpack_public_path__ + "static/010-1a3ee22c17bc7c12747b3ced2c5bc543.jpg";